module.exports = __webpack_public_path__ + "./fonts/lato-regular-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/lato-regular-webfont.eot
// module id = 22
// module chunks = 0